import { useMemo } from 'react'

import { isDraftSaveAction } from '../../../Draft'
import { RequestDraftCloseActionSelectModal } from '../../RequestDraftCloseActionSelectModal'

export function useRequestDraftCloseConfirmation(setDraft) {
  return useMemo(
    () => ({
      Component: RequestDraftCloseActionSelectModal,
      onSubmit: action => {
        if (!isDraftSaveAction(action)) {
          setDraft(null, 0)
        }
      },
    }),
    [setDraft]
  )
}
